import React from 'react';
import { Select, MenuItem, FormControl, FormHelperText } from '@mui/material';

function SelectInput(props) {
  const { errortext, options, placeholder } = props;

  return (
    <FormControl {...props} {...(errortext && { error: true })}>
      <Select {...props} displayEmpty color="success" defaultValue="">
        <MenuItem disabled value="">
          <em>{placeholder}</em>
        </MenuItem>
        {options.map(option => {
          return (
            <MenuItem key={option.id} value={option.id}>
              <em>{option.name}</em>
            </MenuItem>
          );
        })}
      </Select>
      {errortext && <FormHelperText>{errortext}</FormHelperText>}
    </FormControl>
  );
}

export default SelectInput;
